module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }